import React, { useState, useCallback, useRef } from 'react';
import { Col } from 'react-bootstrap';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import AffiliationsAwardsTab from './AffiliationsAwardsTab';
import ProviderInformationTab from './ProviderInformationTab';
import { t } from 'i18next';

const RightSection = ({
  locationHandler,
  affiliatedDoctorsHandler,
  doctorDetails,
  addressIndex,
  affiliatedDoctorsAddress,
}) => {
  const [selectedTab, setSelectedTab] = useState('provider-information');
  const affiliationTabRef = useRef(1);

  const selectAwardsTab = useCallback(() => {
    setTimeout(() => {
      if (affiliationTabRef && affiliationTabRef?.current) {
        affiliationTabRef?.current?.focus();
      }
    }, 100);
    setSelectedTab('awards-recognitions');
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });

  return (
    <>
      <Col sm={9}>
        <div className="details-section secondary-background">
          <div className="tabs-section">
            <Tabs defaultTab={selectedTab}>
              <TabList className="d-flex">
                <p>
                  <Tab
                    onClick={() => setSelectedTab('provider-information')}
                    tabFor="provider-information"
                    aria-labelledby="provider-information-tab-info"
                  >
                    {t('find_provider.provider_information')}
                  </Tab>
                </p>
                <p>
                  <Tab
                    onClick={() => setSelectedTab('awards-recognitions')}
                    tabFor="awards-recognitions"
                    aria-labelledby="awards-recognitions-tab-info"
                  >
                    {t('find_provider.affiliations')},{' '}
                    {t('find_provider.awards_and_recognitions')}
                  </Tab>
                </p>
                <p
                  className="sr-only"
                  id="provider-information-tab-info"
                  aria-hidden={true}
                >
                  {selectedTab === 'provider-information'
                    ? 'tab '
                    : 'click to select '}
                  {t('find_provider.provider_information')}
                </p>
                <p
                  className="sr-only"
                  id="awards-recognitions-tab-info"
                  aria-hidden={true}
                >
                  {selectedTab === 'awards-recognitions'
                    ? 'tab '
                    : 'click to select '}
                  {t('find_provider.affiliations')},{' '}
                  {t('find_provider.awards_and_recognitions')}
                </p>
              </TabList>
              <TabPanel tabId="provider-information">
                <ProviderInformationTab
                  locationHandler={locationHandler}
                  doctorDetails={doctorDetails}
                  addressIndex={addressIndex}
                  selectAffiliationsTab={selectAwardsTab}
                  affiliatedDoctorsAddress={affiliatedDoctorsAddress}
                />
              </TabPanel>
              <TabPanel tabId="awards-recognitions">
                <AffiliationsAwardsTab
                  affiliatedDoctorsHandler={affiliatedDoctorsHandler}
                  doctorDetails={doctorDetails}
                  focusRef={affiliationTabRef}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </Col>
    </>
  );
};
export default RightSection;
